import React from 'react'
import ReactDOM from 'react-dom/client'
import { DatadogProvider } from '@datadog/openfeature-browser'
import { init as initFullStory } from '@fullstory/browser'
import { CssBaseline } from '@mui/material'
import { OpenFeature, OpenFeatureProvider } from '@openfeature/react-sdk'
import * as Sentry from '@sentry/react'

import App from './App'
import AllProviders from './providers'

import './index.css'

const datadogProvider = new DatadogProvider({
  applicationId: 'Protect Web',
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  env:
    window.location.href.includes('meshifyprotect.com') || window.location.href.includes('meshify.com')
      ? 'Production'
      : window.location.href.includes('meshify.co')
        ? 'Staging'
        : 'Development',
})
OpenFeature.setProvider(datadogProvider)

initFullStory({ orgId: 'o-1SRWH4-na1' })

if (!window.location.href.includes('localhost') && !window.location.href.includes('127.0.0.1')) {
  Sentry.init({
    dsn: 'https://a1a5537744fd62733309625342fede4c@o114884.ingest.us.sentry.io/4509055303942144',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <OpenFeatureProvider>
      <AllProviders>
        <CssBaseline />
        <App />
      </AllProviders>
    </OpenFeatureProvider>
  </React.StrictMode>
)
